import beveatApiStaging from '../api/staging_beveat_api';
import beveatApiProduction from '../api/production_beveat_api';
import { urls, commonConfigs } from "../../config";
import {
  getLocalRefreshToken,
  updateLocalAccessToken,
} from './local_service';

let isSessionExpiredAlertShown = false;

export const showSessionExpiredAlert = () => {
  if (!isSessionExpiredAlertShown) {
    isSessionExpiredAlertShown = true;
    alert('Your session has expired. Please login again.');
    return true; // Alert was shown
  }
  return false; // Alert was already shown
};

export const resetSessionExpiredAlert = () => {
  isSessionExpiredAlertShown = false;
};

function getApiInstance() {
  if (process.env.REACT_APP_ENV === "staging") {
    return beveatApiStaging;
  } else {
    return beveatApiProduction;
  }
}

function getRefreshTokenUrl() {
  const baseUrl = process.env.REACT_APP_ENV === "staging"
    ? urls.baseUrl
    : urls.prodUrl;
  
  return baseUrl + commonConfigs.apiUrls.refreshAccessToken();
}

class AuthenticationService {
  refreshAccessToken() {
    const api = getApiInstance();
    const refreshAccessTokenUrl = getRefreshTokenUrl();
    return api
      .post(refreshAccessTokenUrl, {
        refresh_token: getLocalRefreshToken(),
      })
      .then((response) => {
        // console.log(response);
        const accessToken = response.data?.result?.data?.access_token;
        if (accessToken) {
          updateLocalAccessToken(accessToken);
          console.log('Access token updated successfully');
        }
        return true;
      })
      .catch((e) => {
        return e;
      });
  }
}

export default new AuthenticationService();